import { ButtonType } from './Button'
import { PRIMARY_COLOR, PRIMARY_HOVER_COLOR } from '../../../constants/colors'

export interface ButtonColors {
  neutral: string
  hover: string
  active: string
  disabled: string
  textColor: string
  borderColor: string
  hoverBorderColor?: string
  disabledTextColor: string
  disabledBorderColor: string
}

export const DEFAULT_BUTTON_COLORS: ButtonColors = {
  neutral: ' #ffffff',
  hover: '#f9f9f9',
  active: 'linear-gradient(180deg, #EBEBEC 0%, #E0E2E5 100%)',
  disabled: '#E9EDF1',
  textColor: '#607B82',
  disabledTextColor: '#9A9FA8',
  borderColor: '#CED0DA',
  disabledBorderColor: '#DFE3E9'
}

export const PRIMARY_BUTTON_COLORS: ButtonColors = {
  neutral: PRIMARY_COLOR,
  hover: PRIMARY_HOVER_COLOR,
  active: 'linear-gradient(0deg, #1081D5 0%, #1790EB 100%)',
  disabled: '#E9EDF1',
  textColor: '#fff',
  disabledTextColor: '#9A9FA8',
  borderColor: PRIMARY_COLOR,
  hoverBorderColor: PRIMARY_HOVER_COLOR,
  disabledBorderColor: '#DFE3E9'
}

export const ERROR_BUTTON_COLORS: ButtonColors = {
  neutral: 'linear-gradient(0deg, #EA1919 0%, #F82A2A 100%)',
  hover: '#EB1919',
  active: 'linear-gradient(0deg, #D51010 0%, #EB1919 100%)',
  disabled: '#E9EDF1',
  textColor: '#fff',
  disabledTextColor: '#9A9FA8',
  borderColor: '#d81515',
  disabledBorderColor: '#DFE3E9'
}

export function getButtonColors(buttonType?: ButtonType, hasError?: boolean): ButtonColors {
  if (hasError) {
    return ERROR_BUTTON_COLORS
  }

  if (buttonType === ButtonType.PRIMARY) {
    return PRIMARY_BUTTON_COLORS
  }

  return DEFAULT_BUTTON_COLORS
}
